/** @file Export dialog store: whether the dialog is open (the header button and Mod+Shift+E open it). */
import { createStore } from 'zustand/vanilla';

/** Open state only; the form lives in ExportPanel. */
export interface ExportDialogState {
  open: boolean;
}

/** Closed until asked; ExportDialogHost closes it when the editor frame unmounts. */
export const exportDialogStore = createStore<ExportDialogState>()(() => ({ open: false }));
